import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { PreviewMarkerSetDialogComponent } from './preview-marker-set-dialog.component';
import { MarkerDisplayModule } from '@go-modules/components/marker-display/marker-display.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		MarkerDisplayModule
	],
	declarations: [
		PreviewMarkerSetDialogComponent
	],
	exports: [
		PreviewMarkerSetDialogComponent
	]
})
export class PreviewMarkerSetDialogModule {}
